<gsm-form
  *ngFor="let formHistoryModel of formHistoryData"
  [formDefinitionModel]="formHistoryModel"
  [showEditButton]="!!formHistoryModel.taskId && !isAbschluss"
  [isEditable]="isFormEditable(formHistoryModel)"
  [isEditMode]="isMatchingForm(formHistoryModel, selectedTaskId)"
  [attr.id]="isMatchingForm(formHistoryModel, selectedTaskId) ? 'gsm-selected-task' : null"
  [isLoading]="isMatchingForm(formHistoryModel, loadingTaskId)"
  [isUploading]="isMatchingForm(formHistoryModel, uploadingTaskId)"
  [uploadBytesLoaded]="isMatchingForm(formHistoryModel, uploadingTaskId) ? uploadBytesLoaded : 0"
  [uploadBytesTotal]="isMatchingForm(formHistoryModel, uploadingTaskId) ? uploadBytesTotal : 0"
  (customEventEvent)="customEvent.emit($event)"
  (saveEvent)="saveEvent.emit($event)"
  (editEvent)="editEvent.emit($event)"
  (cancelEvent)="cancelEvent.emit($event)"
  (cancelUploadEvent)="cancelUploadEvent.emit()"
  (formChangeEvent)="handleChildFormChange($event, formHistoryModel.taskId)"
>
</gsm-form>
